import React from "react";
import { Select, Checkbox, Tag } from "antd";

const { Option } = Select;

export interface EmpresaOption {
    value: string;
    label: string;
}

interface EmpresaMultiSelectProps {
    options: EmpresaOption[];
    value?: string[];
    onChange?: (values: string[]) => void;
    style?: React.CSSProperties;
    placeholder?: string;
}

// Formata "29679669000133" -> "29.679.669/0001-33". Se não tiver 14 dígitos, devolve como veio.
const formatarCnpj = (cnpj: string): string => {
    const digitos = (cnpj ?? "").replace(/\D/g, "");
    if (digitos.length !== 14) return cnpj ?? "";
    return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
};

/**
 * Multi-select de empresas com checkbox à esquerda de cada opção (em vez do "check" padrão do
 * antd à direita). As tags selecionadas mostram só o nome da empresa (optionLabelProp="label").
 * Ao passar o mouse (na opção ou na tag) mostra o CNPJ. Aceita value/onChange direto ou via Form.Item.
 */
const EmpresaMultiSelect: React.FC<EmpresaMultiSelectProps> = ({
    options,
    value,
    onChange,
    style,
    placeholder = "Todas",
}) => {
    const selecionadas = value ?? [];

    return (
        <Select
            mode="multiple"
            allowClear
            style={style}
            placeholder={placeholder}
            value={selecionadas}
            onChange={onChange}
            maxTagCount="responsive"
            optionLabelProp="label"
            menuItemSelectedIcon={null}
            dropdownMatchSelectWidth={false}
            dropdownStyle={{ maxWidth: 480 }}
            dropdownClassName="empresa-multiselect-dropdown"
            filterOption={(input, option) =>
                String(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            tagRender={({ label, value: tagValue, closable, onClose }) => (
                <Tag
                    title={`${String(label)} (${formatarCnpj(String(tagValue))})`}
                    closable={closable}
                    onClose={onClose}
                    style={{ marginRight: 3, maxWidth: 150, display: "inline-flex", alignItems: "center" }}
                >
                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
                        {label}
                    </span>
                </Tag>
            )}
        >
            {options.map(opt => (
                <Option key={opt.value} value={opt.value} label={opt.label} title={formatarCnpj(opt.value)}>
                    <span title={formatarCnpj(opt.value)}>
                        <Checkbox
                            checked={selecionadas.includes(opt.value)}
                            style={{ marginRight: 8, pointerEvents: "none" }}
                        />
                        {opt.label}
                    </span>
                </Option>
            ))}
        </Select>
    );
};

export default EmpresaMultiSelect;